import React from 'react';
import Navbar from '../../components/Navbar';
import StudyEdit from '../../components/Study/StudyEdit';
import './StudyEditPage.css';

const StudyEditPage = () => {
  return (
    <div className="study-edit-page">
      <Navbar />
      <div className="study-edit-content">
        <h2>Edit Study</h2>
        <StudyEdit />
      </div>
    </div>
  );
};

export default StudyEditPage;
